var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinIconFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.998,
    r: 16,
    fill: "#fff",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.733 13.251h-3.22a.259.259 0 00-.258.259V23.85c0 .143.116.259.259.259h3.219a.259.259 0 00.258-.259V13.51a.259.259 0 00-.258-.259zM10.124 8.108A2.125 2.125 0 008 10.23c0 1.17.953 2.123 2.124 2.123 1.17 0 2.123-.952 2.123-2.123 0-1.17-.952-2.122-2.123-2.122zM19.92 12.993c-1.292 0-2.248.556-2.828 1.188v-.672a.259.259 0 00-.258-.259H13.75a.259.259 0 00-.259.259V23.85c0 .143.116.26.259.26h3.212a.259.259 0 00.258-.26v-5.116c0-1.725.469-2.396 1.67-2.396 1.31 0 1.414 1.077 1.414 2.485v5.027c0 .143.116.26.258.26h3.214a.258.258 0 00.258-.26v-5.672c0-2.564-.488-5.185-4.114-5.185z",
    fill: "#303996"
  })));
}

export default SvgLinkedinIconFooter;